import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { Typography } from 'amphitheatre';
import { BiRightArrowAlt } from 'react-icons/bi';
import { useInView } from 'react-intersection-observer';

import { StaticImage } from 'gatsby-plugin-image';

const { Header } = Typography;

const LinkWrapper = styled.div`
  a {
    display: flex;
    align-items: center;
    text-decoration: none;
  }

  #arrow {
    color: white;
    margin-left: 0.5rem;
  }
`;

const ContactUsCover = styled.div`
  background: rgba(0, 0, 0, 0.35);
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 1;
`;

const ContactUsBgWrapper = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 0;

  .background-image {
    object-fit: cover;
    object-position: center 30%;

    height: 100%;
    width: 100%;

    transform: scale(1.2);
    transition: all 2s;
  }
`;

const ContactUsText = styled.div`
  box-sizing: border-box;

  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  max-width: 1300px;
  padding: 3rem;
  width: 100%;
  position: absolute;
  z-index: 2;

  #lets-chat {
    font-size: 3rem;
  }

  @media only screen and (min-width: 768px) {
    #lets-chat {
      font-size: 5rem;
    }
  }
`;

const ContactUsWrapper = styled.div`
  height: 60vh;
  overflow: hidden;
  position: relative;

  &.shown {
    .background-image {
      filter: blur(0px);
    }
  }

  &.hidden {
    .background-image {
      filter: blur(6px);
    }
  }
`;

interface LetsChatProp {
  image?: React.ReactNode;
}

function LetsChat({ image }: LetsChatProp): JSX.Element {
  const [ref, inView] = useInView({ triggerOnce: true });

  return (
    <ContactUsWrapper className={inView ? 'shown' : 'hidden'} ref={ref}>
      <ContactUsText>
        <Header id="lets-chat" style={{ fontWeight: 'bold' }}>
          Let's chat
        </Header>
        <LinkWrapper>
          <Link to="/contact-us">
            <Header level={3} style={{ margin: 0 }}>
              Contact Us Today!
            </Header>
            <BiRightArrowAlt id="arrow" style={{ fontSize: '32px' }} />
          </Link>
        </LinkWrapper>
      </ContactUsText>
      <ContactUsCover />
      <ContactUsBgWrapper>
        {image || (
          <StaticImage
            className="background-image"
            src="../../../images/services/contactus.jpg"
            alt="Rocket launching off"
          />
        )}
      </ContactUsBgWrapper>
    </ContactUsWrapper>
  );
}

export default LetsChat;
